/*
 * @Author: tanyaohua
 * @Date: 2019-12-31 13:26:12
 * @Description: 列表图的组件
 */

angular.module('AppCommentModule', []).directive('appComment', [
    'editingCenterAppService',
    function(editingCenterAppService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/app/appComment/appComment.html',
            replace: true,
            transclude: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        commentSet: editingCenterAppService.initCommentSet(), // 初始化评论方式
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {}

                /**
                 * [updateCKSelection description]点赞状态切换
                 */
                $scope.updateCKSelection = function() {
                    $scope.list.THUMB = $scope.list.THUMB === '1' ? '0' : '1';
                };
            },
        };
    },
]);
